import { createActionCreator } from '@pressreader/appstore';

import { MODULE_NAME } from '../../constants';
import { BlockedUserProfile } from '../../types/blocked.user.profile';

const prefix = `${MODULE_NAME}/blocked-users/`;

export const loadBlockedUsersBegan = createActionCreator(`${prefix}load-began`);
export const loadBlockedUsersDone = createActionCreator<{ users: BlockedUserProfile[] }>(`${prefix}load-done`);
export const loadBlockedUsersFailed = createActionCreator(`${prefix}load-failed`);

export const unblockUserAction = createActionCreator<{ profileName: string }>(`${prefix}unblock-user`);
export const userUnblocked = createActionCreator<{ profileName: string }>(`${prefix}user-unblocked`);
